
import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
import { RunnitsCRUDMixin } from '@/mixins/RunnitsCRUDMixin';
import {
	RUNNIT_TYPE,
	RunnitNodeDef,
} from '@run-diffusion/shared';
import { db } from '@/firebase';
import { SNACKBAR_STATUS } from '@/constants/constants';
import { ROUTER } from '@/router/constants';
import _omit from 'lodash/omit';

export default Vue.extend({
	name: 'RunnitReroute',
	metaInfo: {
		title: 'Routing',
	},
	mixins: [
		RunnitsCRUDMixin,
	],
	data () {
		return {
			loading: true,
		};
	},
	computed: {
		...mapState([
			'user',
		]),
		loadingText () {
			const { toolId } = this.$route.query;
			return toolId ? 'Opening tool...' : 'Loading...';
		},
	},
	methods: {
		...mapActions([
			'updateSnackbar',
		]),
		async fetchNodeDef (nodeDefId: string): Promise<RunnitNodeDef> {
			const nodeDefRef = db.collection('runnitNodeDefs').doc(nodeDefId);
			const doc = await nodeDefRef.get();
			if (!doc.exists) {
				throw new Error('Tool not found');
			}

			const nodeDef: RunnitNodeDef = {
				get id () { return doc.id },
				...doc.data(),
			} as RunnitNodeDef;
			if (!nodeDef.publishedAt && !this.user.isAdmin) {
				throw new Error('Tool is not published');
			}
			if (nodeDef.deletedAt) {
				throw new Error('Tool is deleted');
			}
			return nodeDef;
		},
	},
	async mounted () {
		try {
			const { toolId } = this.$route.query;

			let nodeDef: RunnitNodeDef = null;
			if (toolId) {
				nodeDef = await this.fetchNodeDef(toolId);
			} else {
				throw new Error('No tool search criteria not provided');
			}
			if (!nodeDef) {
				throw new Error('Tool not found');
			}

			await this.onAddRunnitClick(nodeDef, RUNNIT_TYPE.SINGLE_TOOL, _omit(this.$route.query, ['toolId']));
		} catch (error: any) {
			console.error('Error in RunnitReroute:', error);
			this.updateSnackbar({
				status: SNACKBAR_STATUS.ERROR,
				message: error.message || 'Error finding tool, please try again',
				show: true,
			});

			// Use replace instead of push to avoid adding the reroute page to the history
			this.routerReplace(this.$route, this.$router, { name: ROUTER.RUNNITS_HOME });
		}
	},
});
